import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

export function getClient(id: string): JQueryPromise<modelsGet.IApiClient>
{
    var endpoint = new URI("api/clients");
    endpoint.addSearch({
        clientId: id
    });

    return api.get<modelsGet.IApiClient>({
        endpoint: endpoint.href()
    });
}

/**
     * Gibt alle Friedhöfe zurück.
     */
export function getClients(): JQueryPromise<modelsGet.IApiClient[]>
{
    var endpoint = new URI("api/clients");

    return api.get<modelsGet.IApiClient[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(client: modelsPost.IApiClient): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/clients",
        data: JSON.stringify(client)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: string, client: modelsPost.IApiClient): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/clients/${id}`,
        data: JSON.stringify(client)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: string): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/clients/${id}`
    });
}